import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useDispatch} from 'react-redux';
import {clearCashAppRecipient, approveCashAppOrder, clearChimeOrder, approveChimeOrder} from '../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';
import Copy from '../../../components/copy';
import LoaderPage from '../../../components/loader_page';


export default ({data, onPayment, chime_order}) => {
    const dispatch = useDispatch(),
          navigate = useNavigate();

    if(!chime_order)
        return <LoaderPage />

    return (
        <>
            <div className="page-title">Chime</div>
            <div className="page-descriptions">
                Send <b>${data.amount}</b> to the recipient <b>{chime_order.receiver.tag}</b> and click the «Payment Made» button to process the request
            </div>


            <div className="amount_input">
                <div className="label">Transfer</div>
                <div className="amount">
                    <div className="symbol">$</div>
                    <div className="value">{data.amount}</div>
                </div>
            </div>

            <div className="cashapp_receiver">
                <div className="label">To recipient</div>
                <div className="user">
                    <div className="avatar">
                        <img src="../../../images/default_avatar.png" />
                    </div>
                    <div className="details">
                        <div className="cashtag">{chime_order.receiver.tag}</div>
                        <div className="name">{chime_order.receiver.name}</div>
                    </div>
                    <Copy value={chime_order.receiver.tag} fill="#A8D81A" size={24} />
                </div>
            </div>

            <div className="mt10"></div>
            <div className="button green" onClick={e => window.open(chime_order.receiver.link, '_blank')}>Open Chime for payment</div>

            <div className="mt20"></div>
            <div className="button blue" onClick={e => {
                dispatch(approveChimeOrder(chime_order.paymentId));
                onPayment();
            }}>Payment made</div>

            <div className="button" onClick={e => {
                dispatch(clearChimeOrder());
                navigate('/');
            }}>Cancel payment</div>
        </>
    )
}